// The visual design is driven by the CSS custom properties in index.css
// (selected through <html data-theme>). These objects keep the same shape the
// older components read from ThemeContext, mapped onto the same palette.
export const theLightTheme = {
    type: 'light',
    primary: '#b43f1a',
    quaternary: '#ece8e0',
    quaternaryLight: '#f5f2ec',
    secondary: '#ffffff',
    tertiary: '#14181d',
    buttonColor: '#14181d',
}

export const theDarkTheme = {
    type: 'dark',
    primary: '#e2603a',
    secondary: '#0d1013',
    quaternary: '#14181d',
    quaternaryLight: '#9aa3ad',
    tertiary: '#e8e6e1',
    buttonColor: '#9aa3ad',
}
